// @flow
import * as React from 'react'

type Props = {
  color?: 'onLight' | 'onDark' | string,
  className?: string,
  size?: number,
}

function Spinner({ color, className, size = 24 }: Props): React.Node {
  const [colorToUse, setColorToUse] = React.useState('rgba(255, 255, 255, 1)')

  React.useEffect(() => {
    function selectColorToUse() {
      switch (color) {
        case 'onLight':
          return 'rgba(0,0,0,0.3)'
        case 'onDark':
          return 'rgba(255, 255, 255, 1)'
        default:
          return color || 'rgba(255, 255, 255, 1)'
      }
    }
    setColorToUse((p) => {
      const n = selectColorToUse()
      return n !== p ? n : p
    })
  }, [color])

  return (
    <svg
      className={className}
      height={`${size}px`}
      preserveAspectRatio="xMidYMid"
      viewBox="0 0 100 100"
      width={`${size}px`}
    >
      <g transform="rotate(0 50 50)">
        <rect
          fill={colorToUse}
          height="12"
          rx="6"
          ry="6"
          width="12"
          x="44"
          y="20"
        >
          <animate
            attributeName="opacity"
            begin="-0.875s"
            dur="1s"
            keyTimes="0;1"
            repeatCount="indefinite"
            values="1;0"
          />
        </rect>
      </g>
      <g transform="rotate(45 50 50)">
        <rect
          fill={colorToUse}
          height="12"
          rx="6"
          ry="6"
          width="12"
          x="44"
          y="20"
        >
          <animate
            attributeName="opacity"
            begin="-0.75s"
            dur="1s"
            keyTimes="0;1"
            repeatCount="indefinite"
            values="1;0"
          />
        </rect>
      </g>
      <g transform="rotate(90 50 50)">
        <rect
          fill={colorToUse}
          height="12"
          rx="6"
          ry="6"
          width="12"
          x="44"
          y="20"
        >
          <animate
            attributeName="opacity"
            begin="-0.625s"
            dur="1s"
            keyTimes="0;1"
            repeatCount="indefinite"
            values="1;0"
          />
        </rect>
      </g>
      <g transform="rotate(135 50 50)">
        <rect
          fill={colorToUse}
          height="12"
          rx="6"
          ry="6"
          width="12"
          x="44"
          y="20"
        >
          <animate
            attributeName="opacity"
            begin="-0.5s"
            dur="1s"
            keyTimes="0;1"
            repeatCount="indefinite"
            values="1;0"
          />
        </rect>
      </g>
      <g transform="rotate(180 50 50)">
        <rect
          fill={colorToUse}
          height="12"
          rx="6"
          ry="6"
          width="12"
          x="44"
          y="20"
        >
          <animate
            attributeName="opacity"
            begin="-0.375s"
            dur="1s"
            keyTimes="0;1"
            repeatCount="indefinite"
            values="1;0"
          />
        </rect>
      </g>
      <g transform="rotate(225 50 50)">
        <rect
          fill={colorToUse}
          height="12"
          rx="6"
          ry="6"
          width="12"
          x="44"
          y="20"
        >
          <animate
            attributeName="opacity"
            begin="-0.25s"
            dur="1s"
            keyTimes="0;1"
            repeatCount="indefinite"
            values="1;0"
          />
        </rect>
      </g>
      <g transform="rotate(270 50 50)">
        <rect
          fill={colorToUse}
          height="12"
          rx="6"
          ry="6"
          width="12"
          x="44"
          y="20"
        >
          <animate
            attributeName="opacity"
            begin="-0.125s"
            dur="1s"
            keyTimes="0;1"
            repeatCount="indefinite"
            values="1;0"
          />
        </rect>
      </g>
      <g transform="rotate(315 50 50)">
        <rect
          fill={colorToUse}
          height="12"
          rx="6"
          ry="6"
          width="12"
          x="44"
          y="20"
        >
          <animate
            attributeName="opacity"
            begin="0s"
            dur="1s"
            keyTimes="0;1"
            repeatCount="indefinite"
            values="1;0"
          />
        </rect>
      </g>
    </svg>
  )
}

export default Spinner
